import React, { useEffect } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PpiForm from '../components/PpiForm';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import useExcludedIngredients from '../features/IngredientContainer/hooks/useExcludedIngredients';
import useIngredients from '../features/IngredientContainer/hooks/useIngredients';
import useCreatePpi from '../features/PpiContainer/hooks/useCreatePpi';
import { getPpiDefaultData } from '../features/PpiContainer/util';
import { ppiInProgressRoute, ppiPublishedRoute } from '../routes';
import { getAvailableLanguages, getLanguage } from '../features/app/selectors';
// import usePpi from '../features/PpiContainer/hooks/usePpi';
import useQueryParams from '../utils/useQueryParams';
// import copyPpi from '../features/PpiContainer/copy';
// import copyPublishedPpi from 'features/PpiContainer/copyPublishedPpi';
// import useGlobalIngredients from 'features/IngredientContainer/hooks/useGlobalIngredients';
// import { MARKET_GLOBAL_LANG } from '../features/app/constants';
import { Mode } from '../components/PpiForm/constants';
import View from './views';
import Splash from '../components/Splash';

import { getStockHierarchy } from '../features/app/stockHierarchySelectors';
import { createPpiVariant } from 'features/PpiContainer/actions';
import createVariantPpi from 'features/PpiContainer/createVariantPpi';
import {
  getvaraintPpi,
  getfetchingVariantPpi,
  getfetchVariantPpiError
} from 'features/PpiContainer/selectors';

function getIngredient(...ingredientLists) {
  let ingredient = null;
  ingredientLists.forEach(ingredientList => {
    if (ingredientList.size > 0) {
      ingredient = ingredientList.first().toJS();
    }
  });
  return ingredient;
}

/**
 * Clears the presentation name of the data. This allows the default name to
 * used rather than the name in english.
 * @param data
 * @returns {*}
 */
// function clearPresentationName(data) {
//   const dataWithoutName = _.cloneDeep(data);
//   _.keys(data.info).forEach(language => {
//     delete dataWithoutName.info[language].presentationName;
//   });
//   return dataWithoutName;
// }

// This only works when copying a Global PPI. It copies EN-IF into all languages for the user.
const PpiCreateVariantView = () => {
  const dispatch = useDispatch();
  // Need both id of PPI and enrichment to create PPI from in order to be able
  // to reload the view without breaking it (can't fetch PPI based on enrichment
  // id).
  const [id, itemCode, status] = useQueryParams('id', 'itemCode', 'status');
  const [createPpi, isSaving, createdPpiId] = useCreatePpi();
  const languages = useSelector(getAvailableLanguages);
  // Currently the ingredients, excluded ingredients and global ingredients is
  // served by three endpoints. Each endpoint has one endpoint and there is no
  // way to know in which category it is. Hence three hooks.
  const [isFetchingIngredients, ingredientRaw] = useIngredients({ itemCode });
  const [isFetchingExcluded, excludedIngredientsRaw] = useExcludedIngredients({
    itemCode
  });
  // const [
  //   isFetchingGlobalIngredients,
  //   globalIngredientRaw
  // ] = useGlobalIngredients({ itemCode });
  const ingredient = getIngredient(
    ingredientRaw,
    excludedIngredientsRaw
    // globalIngredientRaw
  );
  const currLanguage = useSelector(getLanguage);
  const ppi = useSelector(getvaraintPpi);
  const fetchvaraintError = useSelector(getfetchVariantPpiError);
  const isFecthingVariant = useSelector(getfetchingVariantPpi);
  const firstStorageFromConfig = useSelector(getStockHierarchy).toJS();
  const isFetching =
    isFecthingVariant ||
    isFetchingIngredients ||
    // isFetchingGlobalIngredients ||
    isFetchingExcluded;

  useEffect(() => {
    dispatch(createPpiVariant(id, status));
  }, []);

  // Redirect, if created
  if (createdPpiId) {
    return <Redirect to={ppiInProgressRoute(createdPpiId)} />;
  }

  // Render spinner
  if (isFetching) {
    return <ProgressFullscreen open />;
  }

  if (fetchvaraintError) {
    if (status === 'DRAFT') {
      return <Redirect to={ppiInProgressRoute(id)} />;
    }
    if (status === 'PUBLISHED' || status === 'UNPUBLISHED') {
      return <Redirect to={ppiPublishedRoute(id)} />;
    }
  }

  if (!ingredient) {
    return (
      <Splash content="Sorry! The product you are looking for doesn’t exist. This issue must be solved in iFood, please contact the Range Support team (Food.RangeSupport.gl@inter.ikea.com)." />
    );
  }

  function handleCreatePpi(data, callback) {
    createPpi(data, callback);
  }

  const data =
    Object.keys(ppi).length > 0 && createVariantPpi(ppi, languages, status);

  const defaultData = getPpiDefaultData(
    languages,
    ingredient,
    firstStorageFromConfig,
    currLanguage
  );

  View.PpiCreateVariant.visit(data, currLanguage, itemCode);

  return (
    <PpiForm
      showProgress={isFetching}
      data={data}
      defaultData={defaultData}
      isSaving={isSaving}
      dataLabels={{
        title: (formData, { language }) =>
          _.get(formData, `info.${language}.presentationName`)
      }}
      mode={Mode.CREATE}
      onSave={handleCreatePpi}
    />
  );
};

export default PpiCreateVariantView;
